var _Glyphicon;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { Button, Glyphicon } from 'reaxl';
import { formatNumber } from '@atc/string-fns';

/**
 *  FilteredResultsHeader is a custom component that is designed to
 *  allow users to scroll and still have a quick way to view filters
 *  A callback method is exposed for button click.
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FilteredResultsHeader(_ref) {
  let {
    label = '',
    resultCount = 0,
    onFilterClick = () => {},
    inverted = true,
    filterCount = 0,
    ...rest
  } = _ref;
  const textClass = clsx('text-container text-size-200', {
    'text-inverse': inverted
  });
  const showFilterCount = filterCount && filterCount > 0 ? ` (${filterCount})` : '';
  return /*#__PURE__*/_jsx("header", {
    ...rest,
    "data-cmp": "FilteredResultsHeader",
    children: /*#__PURE__*/_jsxs("div", {
      className: "display-flex align-items-center padding-3",
      children: [/*#__PURE__*/_jsxs(Button, {
        className: "margin-right-3",
        bsStyle: "primary",
        onClick: onFilterClick,
        children: [_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
          className: "margin-right-1",
          glyph: "filter"
        })), "Filter", showFilterCount]
      }), /*#__PURE__*/_jsxs("div", {
        className: textClass,
        children: [/*#__PURE__*/_jsx("div", {
          className: "text-bold",
          children: label
        }), /*#__PURE__*/_jsx("div", {
          children: `${formatNumber({
            value: resultCount
          })} ${resultCount === 1 ? 'Result' : 'Results'}`
        })]
      })]
    })
  });
}
export default FilteredResultsHeader;